import { apiInstance } from "@core/api/axios/apiInstance";
import { parseSchema } from "@core/model/parseSchema";
import { iCafeListSchema, type ICafeListType } from "@features/account/model/response/iCafeList.response";

/**
 * plaync 계정에 연결된 피씨방 목록 조회
 * @param signal
 */
export const fetchICafeList = async (signal?: AbortSignal) => {
  const res = await apiInstance.get("/icafe/me/plaync-mappings", { signal });
  return parseSchema<ICafeListType>({
    schema: iCafeListSchema,
    rawData: res?.data,
  });
};
